import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const HrHome = lazy(() => import("../Components/ProfilesType/HR/HrHome/HrHome"));
const Jobs = lazy(() => import("../Components/ProfilesType/HR/Jobs/Jobs"));
const JobApplications = lazy(() => import("../Components/ProfilesType/HR/Jobs/JobApplications"));
export const hrRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><HrHome /></Suspense>,
    },
    {
        path: "jobs",
        element: <Suspense fallback={<GlobalLoading />}><Jobs /></Suspense>,
    },
     {
        path: "jobs/applications/:id",
        element: <Suspense fallback={<GlobalLoading />}><JobApplications /></Suspense>,
    }
]